<style scoped>
a.paginate_button.current {
  background: black !important;
}
input[type="search"] {
  border: 1.5px solid #d8dbe0;
  border-radius: 4px;
  padding: 5px;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background:#1a3665;color:white"
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Master Dokumen Asean CPA
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#ajuan"
          role="tab"
          aria-controls="home"
          aria-selected="false">Master Dokumen  </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-pendukung"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false">Dokumen Pendukung</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-rekomendasi"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false">Dokumen Rekomendasi</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-asean-cpa"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          style="background-color:#486ba7"
          aria-controls="home"
          aria-selected="true">Dokumen Asean CPA</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/dokumen-anggota-umum"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          
          aria-selected="false">Dokumen Anggota Umum</router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
            @keyup="cariData"
          />
          <br />
        </CCol>

        <CCol lg="12" class="table-responsive mt-3">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #status_required="{item}">
              <td class="py-2 text-center">
                <p  v-if="item.status_required == 1" class="text-success font-weight-bold"> Wajib</p>
                <p  v-else class="text-danger font-weight-bold"> Tidak Wajib</p>
              </td>
            </template>
            <template #nama_dokumen="{item}">
              <td class="py-2 text-left">{{item.nama_dokumen ? item.nama_dokumen : "-"}}</td>
            </template>

            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label for="nama_dokument" class="font-weight-bold">Nama Dokumen</label>
                <multiselect
                    label="namaDokumen"
                    placeholder="Pilih Dokumen"
                    @input="(value) => pilihDokumen(value)"
                    v-model="modelMasterDokumen"
                    :options="optionMasterDokumenForDokumenAseanCpa"
                ></multiselect>
              </div>
              <label for class="font-weight-bold">Status Wajib</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="1"
                    v-model="formData.statusRequired"
                    id="aktifGrader"
                    checked
                  />
                  <label class="custom-control-label" for="aktifGrader">Ya</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="0"
                    id="tidak_aktifGrader"
                    v-model="formData.statusRequired"
                  />
                  <label class="custom-control-label" for="tidak_aktifGrader">Tidak</label>
                </div>
                <span v-if="$v.formData.statusRequired.$error" class="text-danger">
                  *Mohon pilih status
                </span>
              </div>
            </CCol>

           
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <CModal
        title="Modal title"
        :show.sync="modalStatus"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postDataStatus">
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Status Wajib</label>
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="1"
                    v-model="formData.statusRequired"
                    id="aktifGrader"
                    checked
                  />
                  <label class="custom-control-label" for="aktifGrader"
                    >Ya</label
                  >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="0"
                    id="tidak_aktifGrader"
                    v-model="formData.statusRequired"
                  />
                  <label class="custom-control-label" for="tidak_aktifGrader"
                    >Tidak</label
                  >
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Edit Status</h6>
        </template>
        <template #footer>
          <CButton @click="modalStatus = false" color="danger">Tutup</CButton>
          <CButton @click="postDataStatus" type="submit" color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import DokumenAseanCpaService from "@/services/datamaster/dokumen/dokumen-asean-cpa.service";
import BaseUrl from "@/services/base-url";
import { AlertUtils } from "@/mixins/AlertUtils"
import { MasterDokumen } from "@/mixins/master/MasterDokumen"

const fields = [
  { key: "no", _style: "width: 8%" },  
  {
    key: "nama_dokumen",
    _style: "text-align: left;"
  },
  {
    key: "status_required",
    label : "Status Dokumen",
    _style: "text-align: center;"
  },
  
  { key: "aksi", _style: "width:15%; text-align: center" }
];

export default {
  name: "Dokumen",
  mixins : [
    AlertUtils,
    MasterDokumen
  ],
  data() {
    return {
      search: "",
      items: [],
      actionPost: "",
      pageSize: "10",
      formData: {
        namaDokumen: "",
        statusRequired : "",
        kodeDokumen: "",
        contohDokumen: "",
        idMasterDokumen: "",
        id_dokumen_pendukung: ""
      },
      pagination: {
        totalPages: 0
      },
      title: "",
      fields,
      fileName: "Pilih File",
      title: "",
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalStatus: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout: null,
      awaitingSearch: false,
      role_status: null
    }
  },
  validations: {
    formData: {
      statusRequired: { required },      
    },
  },
  mounted() {
    this.baseUrl = BaseUrl();
    this.getData("0", this.pageSize, "default");
    this.roleData();
    // comment console console.log(this.pageSize);
     
  },
  watch: {    
    currentPage: function(val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    },
    myModal: function() {
      if(!this.myModal) {
        this.$v.$reset()
        document.getElementById('nama_dokumen').classList.remove('is-valid')
      }
    }
  },
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/data-master/dokumen' );  
      this.role_status = data;
    },
    pilihDokumen(value) {
      this.formData.idMasterDokumen = value.idMasterDokumen;
    },
    setNamaDokumen(value) {
      this.formData.namaDokumen = value;
      this.$v.formData.namaDokumen.$touch();           
      if(!this.$v.formData.namaDokumen.$error) {
        document.getElementById('nama_dokumen').classList.add('is-valid')
      }
    },
  
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      // clear timeout variable
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function() {
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },

    pageChange() {
      this.getData(currentPage, this.pageSize, this.search);
    }, 

    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            DokumenAseanCpaService.deleteDokumen(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                // this.getData("1");
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      // comment console console.log("this function");
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DokumenAseanCpaService.getDokumen(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data);

          // comment console console.log("data parsing table : ", response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;

          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    insertData(formData) {
      // let loader = this.$loading.show({
      //   container: false ? null : this.$refs.formContainer,
      //   canCancel: true,
      //   onCancel: this.onCancel
      // });
      var vm = this;      

      DokumenAseanCpaService.postDokumen(formData).then(
        () => {
          vm.myModal = false;
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              // loader.hide();
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: "success",
            title: "Data Berhasil Ditambah"
          });
          vm.getData("0", "10", "default");
        },
        error => {
          vm.$swal.fire({
            title: "Peringatan!",
            text: error.message,
            icon: "errorr",
            showCancelButton: true
          });
        }
      );
    },

    putData() {
      if (typeof this.formData.contohDokumen === "string") {
        delete this.formData.contohDokumen;
      }

      if (this.formData.contohDokumen === null) {
        delete this.formData.contohDokumen;
      }
      var vm = this;
      DokumenAseanCpaService.putDokumen(this.formData)
        .then(response => {
          vm.modalStatus = false;
          vm.$v.$reset()
          vm.alertEditSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.formData.contohDokumen = null;
      /**
       * #HANDLING#
       * 
       * Handling Upload File Jika File Yang Di Upload Sama
       */
      this.modelMasterDokumen = []

      this.getAllDokumenForDokumenAseanCpa();

      this.fileName = "";
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.modalStatus = true;
      this.formData = item;
      this.actionPost = "update";
    },

    postData() {      
      this.$v.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);
        }           
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }           
      }
    },

    postDataStatus() {    
        this.putData();
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      if (typeof formData.contohDokumen === "string") {
        delete formData.contohDokumen
      }
      if (formData.contohDokumen === null) {
        delete formData.contohDokumen
      }
      DokumenAseanCpaService.postDokumen(formData)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.$v.$reset()
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError();
        });
    },

    fileUpload(e) {      
      this.formData.contohDokumen = e.target.files[0];
      this.fileName = e.target.files[0].name;            
      // comment console console.log(e.target.files);
    },

    closeModal() {
      this.myModal = false;
      this.$v.$reset()
      document.getElementById('nama_dokumen').classList.remove('is-valid')
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
